// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"ec1dfbf8","37":"674c62f5","338":"b1ae7f3a","763":"7baab76a","831":"8149215b"}[chunkId] + ".chunk.js";
};